import { FC, useState } from 'react';
import { ACCORDION_ITEMS } from 'components/FollowSearchResultsNavigation/constants';
import { deleteCookie } from '@doda/common/src/utils/cookieUtil';
import { MAX_SEARCH_CONDITION } from '@doda/common/src/logics/cookie';
import { SearchConditionDataType } from 'components/FollowSearchResultsNavigation/types';
import { EmptyDisplay } from '../EmptyDisplay';
import { ConfirmDisplay } from '../ConfirmDisplay';
import { SearchedConditionsContents } from '../SearchedConditionsContents';

/**
 * 最近検索した条件 アコーディオンメニュー
 * @param searchConditionList 検索条件ラベル取得APIレスポンスのリスト
 * @param updateSearchConditionList 最近検索した条件データ更新関数
 * @param onClickMenuClose 閉じるボタンのクリックイベント
 * @param loginStatus ログイン状態
 */
export interface SearchedConditionsProps {
  searchConditionList: SearchConditionDataType[];
  updateSearchConditionList: (list: SearchConditionDataType[]) => void;
  onClickMenuClose: () => void;
  loginStatus: boolean;
}

export const SearchedConditions: FC<SearchedConditionsProps> = ({
  searchConditionList,
  updateSearchConditionList,
  onClickMenuClose,
  loginStatus,
}) => {
  const [isShowConfirm, setIsShowConfirm] = useState(false);

  // 削除確認画面の表示
  const onClickShowConfirm = () => {
    setIsShowConfirm(true);
  };

  // 「最近検索した条件」一括削除
  const onClickAllDeleteSearchCondition = () => {
    for (let i = 1; i <= MAX_SEARCH_CONDITION; i += 1) {
      deleteCookie(`search_condition${i}`);
    }
    updateSearchConditionList([]);
    onClickMenuClose();
    // メニューを閉じるまで確認画面を表示
    setTimeout(() => {
      setIsShowConfirm(false);
    }, 300);
  };

  if (!searchConditionList.length) {
    return (
      <EmptyDisplay
        label={ACCORDION_ITEMS.searchedConditions.label}
        onClick={onClickMenuClose}
      />
    );
  }

  return (
    <>
      {!isShowConfirm ? (
        <SearchedConditionsContents
          searchConditionList={searchConditionList}
          updateSearchConditionList={updateSearchConditionList}
          onClickShowConfirm={onClickShowConfirm}
          loginStatus={loginStatus}
        />
      ) : (
        <ConfirmDisplay
          label={ACCORDION_ITEMS.searchedConditions.label}
          onClickDelete={onClickAllDeleteSearchCondition}
          setIsShowConfirm={setIsShowConfirm}
        />
      )}
    </>
  );
};
